

import { useTranslations } from "next-intl";
import { Link } from "@/i18n/routing";
import IconExample from "../icons";
import Image from "next/image";


const End = () => {
  const t = useTranslations('Footer');
const te = useTranslations('dev');
    return (
        <footer className="bg-secondary py-10 text-yel ">
  <IconExample/>
              <div className="flex mx-1 md:mx-16 custom:mx-72 flex-wrap text-sm gap-4 items-center justify-center text-yel ">
                 <p >{t('All rights reserved')}</p>
                <p>|</p>
                 <Link href="/privacy-policy"><p className="cursor-pointer">{t('Privacy Policy')} </p></Link>
              
            <p>|</p>
                <Link href="/terms-and-conditions"> <p className="cursor-pointer">{t('Terms and Conditions')} </p></Link>
                
                 <p>|</p>
                  <Link href="/cookies-policy"> <p className="cursor-pointer">{t('Cookies Policy')}</p></Link>

              </div>

              <div className="flex gap-1 justify-center items-start mt-6">
                <p className="text-yel text-xs font-medium">{te('develop')}</p>
                <Link href="/" rel="preload">
                 <div className="relative h-3 w-20 ">
                     <Image
                       src="/evinov.avif"// or "/logo.webp" if using an webp
                       alt="evinov"
                       fill
                       sizes='100%'
                       style={{ objectFit: 'contain' }} // Maintain aspect ratio
                       priority // Ensures it loads faster
                     />
                   </div>
                 </Link>
              </div>
        
      </footer>
      
    );
  };
  
  export default End;
  